module.exports = __webpack_public_path__ + "img/72_13.afba8059.png";